const getCustomerId = () => {
  const formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
  return formPayload.customerId;
};

export default getCustomerId;
